export default "__VITE_ASSET__CP4zCyAF__"